export function scoreTone(score = 0) {
  if (score >= 85) return "excellent"
  if (score >= 70) return "good"
  if (score >= 50) return "warning"
  return "danger"
}

export function priorityLabel(priority) {
  return String(priority || "medium").toLowerCase()
}

export function formatDate(value) {
  if (!value) return "Never"
  return new Date(value).toLocaleString()
}

export function compactNumber(value) {
  return new Intl.NumberFormat("en", { notation: "compact" }).format(Number(value || 0))
}
